const statusPedido = ['Em preparação',
'Pronto para ser despachado',
'Despachado',
'Entregue',
'Entregue/Retornando Origem',
'Finalizado',
'',
'Erro/Aguardando Solução',
'Erro/Sem Solução',
'Cancelado'];

export default { statusPedido };